export function getCardImageProps(card, fallbackImage) {
  const imageUrl = card?.image_url || card?.imageUrl || null;
  const fallbackUrl =
    typeof fallbackImage === "string" ? fallbackImage : fallbackImage?.url;

  if (!imageUrl) {
    return {
      src: fallbackUrl || null,
      alt:
        fallbackImage && typeof fallbackImage === "object"
          ? fallbackImage.alt || ""
          : "",
      isFallback: true,
    };
  }

  return {
    src: imageUrl,
    alt: card?.image_alt || card?.imageAlt || "",
    isFallback: false,
  };
}
